// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.exam_section {
  position: relative;
}
.exam_section a {
  text-decoration: none;
  color: #1B2430;
}
.exam_section a .single-card {
  position: relative;
}
.exam_section a .single-card:hover, .exam_section a .single-card:focus {
  box-shadow: 0 0.5rem 1rem rgba(66, 45, 45, 0.15) !important;
}
.exam_section a .single-card .icons {
  width: 50px;
  height: 50px;
  line-height: 55px;
  border-radius: 50%;
  text-align: center;
  color: #ffffff;
  margin-bottom: -8rem;
}
.exam_section a .single-card .icons i {
  font-size: 1.45rem;
}
.exam_section a .single-card .schedule.icons {
  background: linear-gradient(90deg, #36A1F5 0%, #077EE6 100%);
}
.exam_section a .single-card .adaptive.icons {
  background: linear-gradient(91deg, #07e63f 0%, #09722c 100%);
}
.exam_section a .single-card .custom.icons {
  background: linear-gradient(91deg, #077EE6 0%, #3AC555 100%);
}
.exam_section a .single-card .error.icons {
  background: linear-gradient(90deg, #A10000 0%, #E30303 100%);
}
.exam_section a .single-card .fitness.icons {
  background: linear-gradient(90deg, #F4A00B 0%, #3AC555 100%);
}

.schedule_exams {
  position: relative;
}
.schedule_exams a {
  text-decoration: none;
  color: #1B2430;
}
.schedule_exams .single-card .icons {
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50%;
  padding: 4px;
  background: linear-gradient(90deg, rgba(249, 249, 249, 0.937254902) 0%, #D5D5D5 100%);
  border: 1px solid #D5D5D5;
}
.schedule_exams .single-card .single-card-body .text {
  padding-left: 10px;
}
@media (max-width: 991px) {
  .schedule_exams .single-card .single-card-body .text-left .card-title {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  .schedule_exams .single-card .single-card-body .text-left .card-title {
    font-size: 13px;
  }
  .schedule_exams .single-card .single-card-body .text-left img {
    width: 38px;
    height: 40px;
  }
}
.schedule_exams .single-card .single-card-body .text-right .list-inline {
  margin: 0;
  padding: 0;
}
.schedule_exams .single-card .single-card-body .text-right .list-inline li.list-inline-item {
  padding-left: 8px;
  padding-right: 8px;
  border-left: 1px solid rgba(0, 0, 0, 0.125);
  text-align: center;
}
.schedule_exams .single-card .single-card-body .text-right .list-inline li.list-inline-item:not(:last-child) {
  margin-right: -0.5rem;
}
.schedule_exams .single-card .single-card-body .text-right .list-inline svg {
  width: 25px;
}
@media (max-width: 767px) {
  .schedule_exams .single-card .single-card-body .text-right .list-inline li.list-inline-item {
    padding-left: 10px;
    padding-right: 10px;
  }
  .schedule_exams .single-card .single-card-body .text-right img {
    width: 18px;
    height: 18px;
  }
}
.schedule_exams .NeetSemiGrand .text-left .examTypeImage {
  position: relative;
}
.schedule_exams .NeetSemiGrand .text-left .examTypeImage::before {
  position: absolute;
  content: "\\f02d";
  width: 20px;
  height: 20px;
  padding: 4px;
  right: 0;
  top: 0;
  color: #09722c;
  text-align: center;
  border: 1px solid #09722c;
  background: #ffffff;
  border-radius: 50%;
  font-size: 10px;
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
.schedule_exams .NeetSemiGrand .text-right .list-inline li.list-inline-item {
  position: relative;
}
.schedule_exams .NeetSemiGrand .text-right .list-inline li.list-inline-item:nth-child(2) i {
  color: #077EE6;
}
.schedule_exams .single-card.bg-light {
  background: #EEEEEE !important;
  border: 1px solid #6D6D6D !important;
  border-radius: 5px;
}

.card-header {
  padding-left: 0.6rem;
  margin-bottom: -3px;
}
.card-header .nav-pills .nav-link.active,
.card-header .nav-pills .show > .nav-link {
  font-weight: 700;
  color: #1B2430;
  background-color: transparent !important;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header-tabs {
  margin: 0;
}

.tab-title {
  background: #F2F9FF;
}

@media (max-width: 767px) {
  .card-group {
    display: flex;
    flex-flow: column wrap !important;
  }
  .card-group > .card {
    margin-bottom: 15px;
    border-radius: 0.25rem;
  }
  .card-group > .card + .card {
    border-left: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
  }
}
.sudent_exam_block a {
  text-decoration: none;
  color: #1B2430;
}
.sudent_exam_block .custom_exam_papers {
  position: relative;
}
@media (min-width: 768px) {
  .sudent_exam_block .custom_exam_papers .custom_exam_card .card-header {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.sudent_exam_block .Custom_Exam_Syllabus .card-group .card .subjects-list li:hover,
.sudent_exam_block .Custom_Exam_Syllabus .card-group .card .subjects-list li.active,
.sudent_exam_block .Custom_Exam_Syllabus .card-group .card .chapter-list li:hover,
.sudent_exam_block .Custom_Exam_Syllabus .card-group .card .chapter-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
  padding: 0.2rem 0.5rem;
}
.sudent_exam_block .Custom_Exam_Syllabus .card-group .card .list-unstyled li {
  padding: 0.2rem 0.5rem;
  text-transform: uppercase;
}
@media (max-width: 991px) {
  .sudent_exam_block .Custom_Exam_Syllabus .card-group .card + .card {
    border-left: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
}
@media (max-width: 991px) {
  .sudent_exam_block .Custom_Exam_Syllabus .card-group {
    display: flex;
    flex-flow: column wrap;
  }
  .sudent_exam_block .Custom_Exam_Syllabus .card-group .card {
    flex-direction: inherit;
    margin-bottom: 15px;
  }
}
.sudent_exam_block .table-borderless {
  margin-bottom: 0;
}
.sudent_exam_block .table-borderless td,
.sudent_exam_block .table-borderless th {
  padding: 0.3rem 0.5rem;
  border: 0;
}
.sudent_exam_block .create_custom_timeline {
  position: relative;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline {
  margin-bottom: 2rem;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group {
  margin-bottom: 0.82rem;
  color: #787878;
  background: #F6F6F6;
  border: 1px solid #F6F6F6;
  cursor: pointer;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group:hover, .sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.active {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
  border: 1px solid #B4B4B4;
  border-radius: 5px;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group:hover .card-left i, .sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.active .card-left i {
  color: #5BC6FE;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group:last-child {
  margin-bottom: 0;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group h6 {
  color: #555555;
  font-size: 14px;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group p {
  font-size: 12px;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.add-card {
  background: #ffffff;
  text-align: center;
  padding: 1.15rem 0;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.add-card:hover, .sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.add-card.active {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
  border: 1px solid #c9c9c9;
  border-radius: 5px;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group .card-right .signle-group {
  margin-right: 10px;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group .card-right .signle-group:first-child {
  margin-left: 6px;
}
.sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group .card-right .signle-group:last-child {
  margin-right: 0;
}
@media (max-width: 991px) {
  .sudent_exam_block .create_custom_timeline li.create_custom_single_timeline .card {
    margin: 10px;
  }
}
.sudent_exam_block .create_custom_timeline .card {
  position: relative;
}
.sudent_exam_block .create_custom_timeline .card .branches-list li,
.sudent_exam_block .create_custom_timeline .card .subjects-list li,
.sudent_exam_block .create_custom_timeline .card .sections-list li {
  cursor: pointer;
  border-radius: 2px;
  padding: 0.3rem 0.5rem;
  margin-left: 0.2rem;
  margin-bottom: 0.2rem;
  text-transform: uppercase;
  list-style-type: none;
}
.sudent_exam_block .create_custom_timeline .card .branches-list li:hover, .sudent_exam_block .create_custom_timeline .card .branches-list li.active,
.sudent_exam_block .create_custom_timeline .card .subjects-list li:hover,
.sudent_exam_block .create_custom_timeline .card .subjects-list li.active,
.sudent_exam_block .create_custom_timeline .card .sections-list li:hover,
.sudent_exam_block .create_custom_timeline .card .sections-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
  padding: 0.3rem 0.5rem;
}
@media (min-width: 992px) {
  .sudent_exam_block .aside {
    position: fixed;
    top: 60px;
    right: 0;
    width: 260px;
    z-index: 2;
  }
}

.previous_paper a {
  text-decoration: none;
  color: #1B2430;
}
.previous_paper .oldpaper_list .card {
  cursor: pointer;
}
.previous_paper .oldpaper_list .card i {
  visibility: hidden;
}
.previous_paper .oldpaper_list .card.active, .previous_paper .oldpaper_list .card:hover {
  background: #FEF5E6;
  border: 1px solid #F4A00B;
}
.previous_paper .oldpaper_list .card.active i, .previous_paper .oldpaper_list .card:hover i {
  visibility: visible;
  color: #DF7E00;
}
.previous_paper .aside .topic-list li {
  padding: 0.3rem 0.5rem;
}
.previous_paper .table-borderless {
  margin-bottom: 0;
}
.previous_paper .table-borderless td,
.previous_paper .table-borderless th {
  padding: 0.3rem 0.5rem;
  border: 0;
}
@media (min-width: 992px) {
  .previous_paper .aside {
    position: fixed;
    top: 55px;
    right: 0;
    width: 250px;
  }
}

.adaptiveExam_paper,
.errorExam_paper {
  position: relative;
}
.adaptiveExam_paper .nav-pills .nav-link,
.errorExam_paper .nav-pills .nav-link {
  color: #1B2430;
}
.adaptiveExam_paper .nav-pills .nav-link .card,
.errorExam_paper .nav-pills .nav-link .card {
  border: 1px solid #ffffff;
}
.adaptiveExam_paper .nav-pills .nav-link.active,
.adaptiveExam_paper .nav-pills .show > .nav-link,
.errorExam_paper .nav-pills .nav-link.active,
.errorExam_paper .nav-pills .show > .nav-link {
  color: #1B2430;
  background-color: #007bff;
}
.adaptiveExam_paper .nav-pills .nav-link.active .card,
.adaptiveExam_paper .nav-pills .show > .nav-link .card,
.errorExam_paper .nav-pills .nav-link.active .card,
.errorExam_paper .nav-pills .show > .nav-link .card {
  border: 1px solid #00C596;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.0509803922);
}
.adaptiveExam_paper .nav-pills .nav-link.active .card.green,
.adaptiveExam_paper .nav-pills .show > .nav-link .card.green,
.errorExam_paper .nav-pills .nav-link.active .card.green,
.errorExam_paper .nav-pills .show > .nav-link .card.green {
  border: 1px solid #007bff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.0509803922);
}
.adaptiveExam_paper .nav-pills .nav-link.active .card.orange,
.adaptiveExam_paper .nav-pills .show > .nav-link .card.orange,
.errorExam_paper .nav-pills .nav-link.active .card.orange,
.errorExam_paper .nav-pills .show > .nav-link .card.orange {
  border: 1px solid #F4A00B;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.0509803922);
}
.adaptiveExam_paper .card-group .card .subjects-list li:hover,
.adaptiveExam_paper .card-group .card .subjects-list li.active,
.adaptiveExam_paper .card-group .card .chapter-list li:hover,
.adaptiveExam_paper .card-group .card .chapter-list li.active,
.errorExam_paper .card-group .card .subjects-list li:hover,
.errorExam_paper .card-group .card .subjects-list li.active,
.errorExam_paper .card-group .card .chapter-list li:hover,
.errorExam_paper .card-group .card .chapter-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
  padding: 0.2rem 0.5rem;
}
.adaptiveExam_paper .card-group .card .list-unstyled li,
.errorExam_paper .card-group .card .list-unstyled li {
  padding: 0.2rem 0.5rem;
  text-transform: uppercase;
}
.adaptiveExam_paper .table-borderless,
.errorExam_paper .table-borderless {
  margin-bottom: 0;
}
.adaptiveExam_paper .table-borderless td,
.adaptiveExam_paper .table-borderless th,
.errorExam_paper .table-borderless td,
.errorExam_paper .table-borderless th {
  padding: 0.3rem 0.5rem;
  border: 0;
}
@media (min-width: 992px) {
  .adaptiveExam_paper .aside,
  .errorExam_paper .aside {
    position: fixed;
    top: 55px;
    right: 0;
    width: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/student_module/components/exams/_exam.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AA9WA;EACI,kBAAA;AAiXJ;AA/WI;EACI,qBAAA;EACA,cAAA;AAiXR;AA/WQ;EACI,kBAAA;AAiXZ;AA/WY;EAEI,2DAAA;AAgXhB;AA7WY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AA+WhB;AA7WgB;EACI,kBAAA;AA+WpB;AA3WY;EACI,4DAAA;AA6WhB;AA1WY;EACI,4DAAA;AA4WhB;AAzWY;EACI,4DAAA;AA2WhB;AAxWY;EACI,4DAAA;AA0WhB;AAvWY;EACI,4DAAA;AAyWhB;;AAnWA;EACI,kBAAA;AAsWJ;AApWI;EACI,qBAAA;EACA,cAAA;AAsWR;AAlWQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,qFAAA;EACA,yBAAA;AAoWZ;AAhWY;EACI,kBAAA;AAkWhB;AA9VgB;EACI;IACI,eAAA;EAgWtB;AACF;AA7VgB;EACI;IACI,eAAA;EA+VtB;EA5VkB;IACI,WAAA;IACA,YAAA;EA8VtB;AACF;AAzVgB;EACI,SAAA;EACA,UAAA;AA2VpB;AAzVoB;EACI,iBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;AA2VxB;AAzVwB;EACI,qBAAA;AA2V5B;AAvVoB;EACI,WAAA;AAyVxB;AArVgB;EACI;IACI,kBAAA;IACA,mBAAA;EAuVtB;EApVkB;IACI,WAAA;IACA,YAAA;EAsVtB;AACF;AAhVI;EACI,kBAAA;AAkVR;AAhVQ;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AAkVZ;AA9UI;EACI,kBAAA;AAgVR;AA9UQ;EACI,cAAA;AAgVZ;AA3UI;EACI,8BAAA;EACA,oCAAA;EACA,kBAAA;AA6UR;;AAzUA;EACI,oBAAA;EACA,mBAAA;AA4UJ;AA1UI;;EAEI,gBAAA;EACA,cAAA;EACA,wCAAA;EACA,sCAAA;AA4UR;;AAxUA;EACI,SAAA;AA2UJ;;AAxUA;EACI,mBAAA;AA2UJ;;AAxUA;EACI;IACI,aAAA;IACA,iCAAA;EA2UN;EAvUE;IACI,mBAAA;IACA,sBAAA;EAyUN;EAtUE;IACI,2CAAA;IACA,sBAAA;EAwUN;AACF;AAlUI;EACI,qBAAA;EACA,cDtNC;AC0hBT;AAjUI;EACI,kBAAA;AAmUR;AAjUQ;EACI;IACI,8BAAA;IACA,+BAAA;EAmUd;AACF;AA3TgB;;;;EAII,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AA6TpB;AA1TgB;EACI,sBAAA;EACA,yBAAA;AA4TpB;AAvTQ;EACI;IACI,sDAAA;EAyTd;AACF;AAtTQ;EACI;IACI,aAAA;IACA,sBAAA;EAwTd;EAtTc;IACI,uBAAA;IACA,mBAAA;EAwTlB;AACF;AAlTI;EACI,gBAAA;AAoTR;AAlTQ;;EAEI,sBAAA;EACA,SAAA;AAoTZ;AAhTI;EACI,kBAAA;AAkTR;AAhTQ;EACI,mBAAA;AAkTZ;AAhTY;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAkThB;AAhTgB;EAEI,oDAAA;EACA,yBAAA;EACA,kBAAA;AAiTpB;AA/SoB;EACI,cAAA;AAiTxB;AA7SgB;EACI,gBAAA;AA+SpB;AA5SgB;EACI,cAAA;EACA,eAAA;AA8SpB;AA3SgB;EACI,eAAA;AA6SpB;AA1SgB;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;AA4SpB;AA1SoB;EAEI,oDAAA;EACA,yBAAA;EACA,kBAAA;AA2SxB;AAvSgB;EACI,kBAAA;AAySpB;AAvSoB;EACI,gBAAA;AAySxB;AAtSoB;EACI,eAAA;AAwSxB;AAnSY;EACI;IACI,YAAA;EAqSlB;AACF;AAjSQ;EACI,kBAAA;AAmSZ;AA9RgB;;;EACI,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AAkSpB;AAhSoB;;;;;EAEI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAqSxB;AA9RI;EACG;IACK,eAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,UAAA;EAgSV;AACF;;AA1RI;EACI,qBAAA;EACA,cAAA;AA6RR;AA1RI;EACI,eAAA;AA4RR;AA1RQ;EACI,kBAAA;AA4RZ;AAzRQ;EAEI,mBAAA;EACA,yBAAA;AA0RZ;AAxRY;EACI,mBAAA;EACA,cAAA;AA0RhB;AApRQ;EACI,sBAAA;AAsRZ;AAlRI;EACI,gBAAA;AAoRR;AAlRQ;;EAEI,sBAAA;EACA,SAAA;AAoRZ;AAhRQ;EADJ;IAEQ,eAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;EAmRV;AACF;;AA/QA;;EAEI,kBAAA;AAkRJ;AAhRI;;EACI,cAAA;AAmRR;AAjRQ;;EACI,yBAAA;AAoRZ;AAhRI;;;;EAEI,cAAA;EACA,yBAAA;AAoRR;AAlRQ;;;;EACI,yBAAA;EACA,oDAAA;AAuRZ;AApRQ;;;;EACI,yBAAA;EACA,oDAAA;AAyRZ;AAtRQ;;;;EACI,yBAAA;EACA,oDAAA;AA2RZ;AApRY;;;;;;;;EAII,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AA0RhB;AAvRY;;EACI,sBAAA;EACA,yBAAA;AA0RhB;AArRI;;EACI,gBAAA;AAwRR;AAtRQ;;;;EAEI,sBAAA;EACA,SAAA;AA0RZ;AAtRQ;EADJ;;IAEQ,eAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;EA0RV;AACF","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import '../../../config';\n\n.exam_section {\n    position: relative;\n\n    a {\n        text-decoration: none;\n        color: #1B2430;\n\n        .single-card {\n            position: relative;\n\n            &:hover,\n            &:focus {\n                box-shadow: 0 0.5rem 1rem rgba(66, 45, 45, 0.15) !important\n            }\n\n            .icons {\n                width: 50px;\n                height: 50px;\n                line-height: 55px;\n                border-radius: 50%;\n                text-align: center;\n                color: #ffffff;\n                margin-bottom: -8rem;\n\n                i {\n                    font-size: 1.45rem;\n                }\n            }\n\n            .schedule.icons {\n                background: linear-gradient(90deg, #36A1F5 0%, #077EE6 100%);\n            }\n\n            .adaptive.icons {\n                background: linear-gradient(91deg, #07e63f 0%, #09722c 100%);\n            }\n\n            .custom.icons {\n                background: linear-gradient(91deg, #077EE6 0%, #3AC555 100%);\n            }\n\n            .error.icons {\n                background: linear-gradient(90deg, #A10000 0%, #E30303 100%);\n            }\n\n            .fitness.icons {\n                background: linear-gradient(90deg, #F4A00B 0%, #3AC555 100%);\n            }\n        }\n    }\n}\n\n.schedule_exams {\n    position: relative;\n\n    a {\n        text-decoration: none;\n        color: #1B2430;\n    }\n\n    .single-card {\n        .icons {\n            width: 50px;\n            height: 50px;\n            overflow: hidden;\n            border-radius: 50%;\n            padding: 4px;\n            background: linear-gradient(90deg, #F9F9F9EF 0%, #D5D5D5 100%);\n            border: 1px solid #D5D5D5;\n        }\n\n        .single-card-body {\n            .text {\n                padding-left: 10px;\n            }\n\n            .text-left {\n                @media (max-width: 991px) {\n                    .card-title {\n                        font-size: 14px;\n                    }\n                }\n\n                @media (max-width: 767px) {\n                    .card-title {\n                        font-size: 13px;\n                    }\n\n                    img {\n                        width: 38px;\n                        height: 40px;\n                    }\n                }\n            }\n\n            .text-right {\n                .list-inline {\n                    margin: 0;\n                    padding: 0;\n\n                    li.list-inline-item {\n                        padding-left: 8px;\n                        padding-right: 8px;\n                        border-left: 1px solid rgba(0, 0, 0, 0.125);\n                        text-align: center;\n\n                        &:not(:last-child) {\n                            margin-right: -0.5rem;\n                        }\n                    }\n\n                    svg {\n                        width: 25px;\n                    }\n                }\n\n                @media (max-width: 767px) {\n                    .list-inline li.list-inline-item {\n                        padding-left: 10px;\n                        padding-right: 10px;\n                    }\n\n                    img {\n                        width: 18px;\n                        height: 18px;\n                    }\n                }\n            }\n        }\n    }\n\n    .NeetSemiGrand .text-left .examTypeImage {\n        position: relative;\n\n        &::before {\n            position: absolute;\n            content: \"\\f02d\";\n            width: 20px;\n            height: 20px;\n            padding: 4px;\n            right: 0;\n            top: 0;\n            color: #09722c;\n            text-align: center;\n            border: 1px solid #09722c;\n            background: #ffffff;\n            border-radius: 50%;\n            font-size: 10px;\n            font-family: \"Font Awesome 5 Pro\";\n            font-weight: 900;\n            display: inline-block;\n            font-style: normal;\n            font-variant: normal;\n            text-rendering: auto;\n            line-height: 1;\n        }\n    }\n\n    .NeetSemiGrand .text-right .list-inline li.list-inline-item {\n        position: relative;\n\n        &:nth-child(2) i {\n            color: #077EE6;\n        }\n    }\n\n\n    .single-card.bg-light {\n        background: #EEEEEE !important;\n        border: 1px solid #6D6D6D !important;\n        border-radius: 5px;\n    }\n}\n\n.card-header {\n    padding-left: 0.6rem;\n    margin-bottom: -3px;\n\n    .nav-pills .nav-link.active,\n    .nav-pills .show>.nav-link {\n        font-weight: 700;\n        color: #1B2430;\n        background-color: transparent !important;\n        border: 1px solid rgba(0, 0, 0, 0.125);\n    }\n}\n\n.card-header-tabs {\n    margin: 0;\n}\n\n.tab-title {\n    background: #F2F9FF;\n}\n\n@media (max-width: 767px) {\n    .card-group {\n        display: flex;\n        flex-flow: column wrap !important;\n\n    }\n\n    .card-group>.card {\n        margin-bottom: 15px;\n        border-radius: 0.25rem;\n    }\n\n    .card-group>.card+.card {\n        border-left: 1px solid rgba(0, 0, 0, 0.125);\n        border-radius: 0.25rem;\n    }\n}\n\n\n\n.sudent_exam_block {\n    a {\n        text-decoration: none;\n        color: $theme2;\n    }\n\n    .custom_exam_papers {\n        position: relative;\n\n        @media (min-width: 768px) {\n            .custom_exam_card .card-header {\n                border-bottom-left-radius: 4px;\n                border-bottom-right-radius: 4px;\n            }\n        }\n    }\n\n    .Custom_Exam_Syllabus {\n        .card-group {\n            .card {\n\n                .subjects-list li:hover,\n                .subjects-list li.active,\n                .chapter-list li:hover,\n                .chapter-list li.active {\n                    cursor: pointer;\n                    border-radius: 2px;\n                    background: #EFEFEF;\n                    padding: 0.2rem 0.5rem;\n                }\n\n                .list-unstyled li {\n                    padding: 0.2rem 0.5rem;\n                    text-transform: uppercase;\n                }\n            }\n        }\n\n        @media (max-width: 991px) {\n            .card-group .card+.card {\n                border-left: 1px solid rgba(0, 0, 0, 0.125) !important;\n            }\n        }\n\n        @media (max-width: 991px) {\n            .card-group {\n                display: flex;\n                flex-flow: column wrap;\n\n                .card {\n                    flex-direction: inherit;\n                    margin-bottom: 15px;\n                }\n            }\n        }\n    }\n\n\n    .table-borderless {\n        margin-bottom: 0;\n\n        td,\n        th {\n            padding: 0.3rem 0.5rem;\n            border: 0;\n        }\n    }\n\n    .create_custom_timeline {\n        position: relative;\n\n        li.create_custom_single_timeline {\n            margin-bottom: 2rem;\n\n            .custom-groups .single-card-group {\n                margin-bottom: 0.82rem;\n                color: #787878;\n                background: #F6F6F6;\n                border: 1px solid #F6F6F6;\n                cursor: pointer;\n\n                &:hover,\n                &.active {\n                    box-shadow: 0px 3px 10px #0000000D;\n                    border: 1px solid #B4B4B4;\n                    border-radius: 5px;\n\n                    .card-left i {\n                        color: #5BC6FE;\n                    }\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n\n                h6 {\n                    color: #555555;\n                    font-size: 14px;\n                }\n\n                p {\n                    font-size: 12px;\n                }\n\n                &.add-card {\n                    background: #ffffff;\n                    text-align: center;\n                    padding: 1.15rem 0;\n\n                    &:hover,\n                    &.active {\n                        box-shadow: 0px 3px 10px #0000000D;\n                        border: 1px solid #c9c9c9;\n                        border-radius: 5px;\n                    }\n                }\n\n                .card-right .signle-group {\n                    margin-right: 10px;\n\n                    &:first-child {\n                        margin-left: 6px;\n                    }\n\n                    &:last-child {\n                        margin-right: 0;\n                    }\n                }\n            }\n\n            @media (max-width: 991px) {\n                .card {\n                    margin: 10px;\n                }\n            }\n        }\n\n        .card {\n            position: relative;\n\n            .branches-list,\n            .subjects-list,\n            .sections-list {\n                li {\n                    cursor: pointer;\n                    border-radius: 2px;\n                    padding: 0.3rem 0.5rem;\n                    margin-left: 0.2rem;\n                    margin-bottom: 0.2rem;\n                    text-transform: uppercase;\n                    list-style-type: none;\n\n                    &:hover,\n                    &.active {\n                        cursor: pointer;\n                        border-radius: 2px;\n                        background: #EFEFEF;\n                        padding: 0.3rem 0.5rem;\n                    }\n                }\n            }\n        }\n    }\n\n    @media (min-width: 992px) {\n       .aside {\n            position: fixed;\n            top: 60px;\n            right: 0;\n            width: 260px;\n            z-index: 2;\n        }\n    }\n\n}\n\n.previous_paper {\n    a {\n        text-decoration: none;\n        color: #1B2430;\n    }\n\n    .oldpaper_list .card {\n        cursor: pointer;\n\n        i {\n            visibility: hidden;\n        }\n\n        &.active,\n        &:hover {\n            background: #FEF5E6;\n            border: 1px solid #F4A00B;\n\n            i {\n                visibility: visible;\n                color: #DF7E00;\n            }\n        }\n    }\n\n    .aside {\n        .topic-list li {\n            padding: 0.3rem 0.5rem;\n        }\n    }\n\n    .table-borderless {\n        margin-bottom: 0;\n\n        td,\n        th {\n            padding: 0.3rem 0.5rem;\n            border: 0;\n        }\n    }\n    .aside {\n        @media (min-width: 992px) {\n            position: fixed;\n            top: 55px;\n            right: 0;\n            width: 250px;\n        }\n    }\n}\n\n.adaptiveExam_paper,\n.errorExam_paper {\n    position: relative;\n\n    .nav-pills .nav-link {\n        color: #1B2430;\n\n        .card {\n            border: 1px solid #ffffff;\n        }\n    }\n\n    .nav-pills .nav-link.active,\n    .nav-pills .show>.nav-link {\n        color: #1B2430;\n        background-color: #007bff;\n\n        .card {\n            border: 1px solid #00C596;\n            box-shadow: 0px 0px 20px #0000000D;\n        }\n\n        .card.green {\n            border: 1px solid #007bff;\n            box-shadow: 0px 0px 20px #0000000D;\n        }\n\n        .card.orange {\n            border: 1px solid #F4A00B;\n            box-shadow: 0px 0px 20px #0000000D;\n        }\n    }\n\n    .card-group {\n        .card {\n\n            .subjects-list li:hover,\n            .subjects-list li.active,\n            .chapter-list li:hover,\n            .chapter-list li.active {\n                cursor: pointer;\n                border-radius: 2px;\n                background: #EFEFEF;\n                padding: 0.2rem 0.5rem;\n            }\n\n            .list-unstyled li {\n                padding: 0.2rem 0.5rem;\n                text-transform: uppercase;\n            }\n        }\n    }\n\n    .table-borderless {\n        margin-bottom: 0;\n\n        td,\n        th {\n            padding: 0.3rem 0.5rem;\n            border: 0;\n        }\n    }\n    .aside {\n        @media (min-width: 992px) {\n            position: fixed;\n            top: 55px;\n            right: 0;\n            width: 250px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
